export enum AGENCY_TYPE {
  AGENCY = 'AGENCY',
  MGA = 'MGA',
}
